import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SchemaForm from '@components/forms/SchemaForm';
import DocumentsPanel from './DocumentsPanel';
import styles from './OnboardingTabs.module.css';

/* In-portal onboarding, split in two: (1) Documents — the KYC uploads/values;
   (2) Details — the onboarding form (SchemaForm) for the subject's own record.
   A Skip button lets them move on to the app (the shell still keeps them here
   while the mandatory onboarding documents are pending). Shared by the doctor
   and clinic-admin portals. */

export default function OnboardingTabs({ kind, statusQuery, submit, homePath }) {
  const navigate = useNavigate();
  // Doctors capture their own details first, then upload documents; clinics keep documents first.
  const detailsFirst = kind === 'doctor';
  const [tab, setTab] = useState(detailsFirst ? 'details' : 'documents');
  const recordId = statusQuery.data?.subjectId || null;

  const tabOrder = detailsFirst
    ? [['details', 'Details'], ['documents', 'Documents']]
    : [['documents', 'Documents'], ['details', 'Details']];

  return (
    <div className={styles.wrap}>
      <div className={styles.tabs}>
        {tabOrder.map(([key, label], i) => (
          <button
            key={key}
            className={`${styles.tab} ${tab === key ? styles.on : ''}`}
            onClick={() => setTab(key)}
          >
            {i + 1} · {label}
          </button>
        ))}
        {tab === 'details' && (
          <>
            <div className={styles.spacer} />
            <button className={styles.skip} onClick={() => navigate(homePath)}>
              Skip for now →
            </button>
          </>
        )}
      </div>

      {tab === 'documents' ? (
        <>
          <DocumentsPanel query={statusQuery} submit={submit} />
          <div className={styles.foot}>
            <button className={styles.go} onClick={() => navigate(homePath)}>
              Continue to app →
            </button>
          </div>
        </>
      ) : recordId ? (
        <SchemaForm kind={kind} id={recordId} skipSections={['uploads', 'permissions']} onClose={() => navigate(homePath)} onSaved={() => {}} />
      ) : (
        <div className={styles.loading}>Loading your details…</div>
      )}
    </div>
  );
}
